import { productFragments } from '@xbcb/compliance-queries';
import { getOneQueryLite } from '@xbcb/shared-queries';
import { RecordType } from '@xbcb/shared-types';

export const GET_PRODUCT = getOneQueryLite({
  recordName: RecordType.PRODUCT,
  fields: `...productFragment`,
  fragments: productFragments,
  queryName: 'getProduct',
});
